import { AttachmentsEndpoint } from 'entities/orderAttachments/api/constants'
import { axiosApi } from 'shared/api/axios'

export const getArchiveOfAllDocuments = async (
    orderId: number,
    paymentId?: number | null,
) => {
    try {
        const response = await axiosApi.get<Blob>(
            `${AttachmentsEndpoint.archive}/${orderId}`,
            {
                responseType: 'blob',
                params: {
                    payment_id: paymentId,
                },
            },
        )

        return { archive: response.data }
    } catch (err) {
        console.error(err)
        throw new Error('Ошибка получение документов')
    }
}
